export default "__VITE_ASSET__1f0904fd__"